export type FontEntry = {
  name: string;
  importSnippet: string;
  /** Pre-rendered SVG shown in the theme editor's font picker (generated by
   * `pnpm -F app font:previews`) — lets users see a font without loading it. */
  preview?: string;
};

/**
 * Fonts offered in the theme editor's font picker. All are self-hosted in
 * app/public/fonts. If you add or rename one, regenerate the picker previews:
 * `pnpm -F app font:previews`
 */
export const fonts: FontEntry[] = [
  {
    name: "Satoshi",
    importSnippet: "@import url('/fonts/Satoshi.css');",
    preview: "/font-previews/Satoshi.svg",
  },
  {
    name: "General Sans",
    importSnippet: "@import url('/fonts/GeneralSans.css');",
    preview: "/font-previews/GeneralSans.svg",
  },
  {
    name: "Public Sans",
    importSnippet: "@import url('/fonts/PublicSans.css');",
    preview: "/font-previews/PublicSans.svg",
  },
  {
    name: "Hubot Sans",
    importSnippet: "@import url('/fonts/HubotSans.css');",
    preview: "/font-previews/HubotSans.svg",
  },
  {
    name: "Open Runde",
    importSnippet: "@import url('/fonts/OpenRunde.css');",
    preview: "/font-previews/OpenRunde.svg",
  },
  {
    name: "Cabinet Grotesk",
    importSnippet: "@import url('/fonts/CabinetGrotesk.css');",
    preview: "/font-previews/CabinetGrotesk.svg",
  },
  {
    name: "Switzer",
    importSnippet: "@import url('/fonts/Switzer.css');",
    preview: "/font-previews/Switzer.svg",
  },
  {
    name: "Shantell Sans",
    importSnippet: "@import url('/fonts/ShantellSans.css');",
    preview: "/font-previews/ShantellSans.svg",
  },
];

/**
 * Fonts that are no longer offered in the picker but MUST remain loadable:
 * existing customer charts have these names baked into meta.themeEditor, and
 * removing the import mapping would silently change how their charts render.
 * DO NOT delete entries from this list.
 */
export const legacyFonts: FontEntry[] = [
  {
    name: "IBM Plex Sans",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500&display=swap');",
  },
  {
    name: "Inclusive Sans",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Inclusive+Sans&display=swap');",
  },
  {
    name: "Space Grotesk",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk&display=swap');",
  },
  {
    name: "Onest",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Onest:wght@300;400&display=swap');",
  },
  {
    name: "Overpass",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Overpass&display=swap');",
  },
  {
    name: "Kalam",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Kalam&display=swap');",
  },
  {
    name: "Nanum Pen Script",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap');",
  },
  {
    name: "REM",
    importSnippet:
      "@import url('https://fonts.googleapis.com/css2?family=REM:wght@400;500&display=swap');",
  },
];

/** Every font the app knows how to load (picker + legacy). */
export const allFonts: FontEntry[] = [...fonts, ...legacyFonts];
